import { createApp } from 'vue';
import AvifToWebpConverter from '../Components/AvifToWebpConverter.vue';

const root = document.getElementById('avif-to-webp-converter');
if (root) {
  createApp(AvifToWebpConverter).mount('#avif-to-webp-converter');
}
